function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getTheme, Stack } from 'office-ui-fabric-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReorderList(_ref) {
  let {
    items,
    getItemId,
    renderItems,
    renderHeaderItems,
    onChange
  } = _ref;
  const [sortItems, setSortItems] = useState(items);
  const theme = getTheme();
  useEffect(() => {
    setSortItems(items !== null && items !== void 0 ? items : []);
  }, [items]);
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const newItems = reorder(sortItems, result.source.index, result.destination.index);
    setSortItems(newItems);
    onChange(newItems);
  };
  const rowStyles = {
    root: {
      borderBottom: "solid 1px ".concat(theme.palette.neutralLighterAlt),
      padding: '11px 0px 12px 15px',
      color: theme.palette.neutralPrimary,
      cursor: 'move',
      selectors: {
        ':hover': {
          boxShadow: theme.effects.elevation8,
          backgroundColor: theme.palette.neutralLighterAlt
        }
      }
    }
  };
  const headerStyles = {
    root: {
      borderBottom: "solid 1px ".concat(theme.palette.neutralLighterAlt),
      padding: '24px 0px 9px 15px'
    }
  };
  return /*#__PURE__*/_jsx(DragDropContext, {
    onDragEnd: onDragEnd,
    children: /*#__PURE__*/_jsx(Droppable, {
      droppableId: "droppable",
      children: provided => /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, provided.droppableProps), {}, {
        ref: provided.innerRef,
        children: [/*#__PURE__*/_jsx(Stack, {
          styles: headerStyles,
          grow: true,
          children: renderHeaderItems()
        }), sortItems.map((item, index) => {
          const id = getItemId(item);
          return /*#__PURE__*/_jsx(Draggable, {
            draggableId: id,
            index: index,
            children: provided => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
              ref: provided.innerRef
            }, provided.draggableProps), provided.dragHandleProps), {}, {
              children: /*#__PURE__*/_jsx(Stack, {
                styles: rowStyles,
                grow: true,
                children: renderItems(item)
              })
            }))
          }, id);
        }), provided.placeholder]
      }))
    })
  });
}